import { queryOptions, skipToken } from "@tanstack/react-query";

import { api } from "@/api/api";
import type { FindHotelOffersOutputDto } from "@/types/codegen";
import { toTitleCase } from "@/utils/titleCase";

interface HotelOfferQueryParams {
  hotelId: string;
  searchResultKey: string;
  searchResultToken: string;
}

function formatRoomName(name: string): string {
  if (!name || name.trim().length === 0) return "";

  // common typos
  const fixedTypos = name
    .replace(/ROOK/gi, "ROOM")
    .replace(/RESRT/gi, "RESORT")
    .trim();

  return toTitleCase(fixedTypos);
}

export const hotelOfferQueryOptions = (params: HotelOfferQueryParams | null) =>
  queryOptions({
    queryKey: ["hotel-offer", params] as const,
    queryFn: params
      ? ({ signal }) =>
          api.get<FindHotelOffersOutputDto>(
            `/hotels/${params.hotelId}/offers`,
            {
              params: {
                searchResultKey: params.searchResultKey,
                searchResultToken: params.searchResultToken,
              },
              signal,
            },
          )
      : skipToken,
    enabled: !!params,
    select: (response) => {
      return response.data.data.map((offer) => ({
        offerId: offer.offerId,
        packageToken: offer.packageToken,
        price: offer.price,
        rooms: offer.rooms.map((room) => ({
          ...room,
          options: room.options.map((option) => ({
            ...option,
            name: formatRoomName(option.name),
            description: option.description.trim(),
            boardBasis: option.boardBasis?.trim().toUpperCase(),
          })),
        })),
      }));
    },
    throwOnError: false,
  });
